import React, {useState} from 'react';
import {ProgressBarWithPause} from "../shared/index";
import {notificationService} from "../shared/lib/notification/notification";


const TmpPage = () => {
    const [isPaused, setIsPaused] = useState(false);
    const [isStart, setIsStart] = useState(false);

    const styleBtn = {fontSize: "2rem", color: "white", background: "blue", height: "3rem"}
    
    const onEnd = () => {
        console.log("onEnd")
        setIsStart(false)
        notificationService.success("Дія завершена!");
    }

    const handleStart = () => {
        const nextState = !isStart;
        setIsStart(nextState);
        if (nextState) {
            notificationService.info("Процес запущено...", 12000);
        }
    };

    return (
        <div
            style={{display: "flex", marginTop: "10rem", flexDirection: "column", gap: "0.5rem", alignItems: "center"}}>
            <div style={{height: "1rem", width: "100%"}}>
                <ProgressBarWithPause isStart={isStart} isPause={isPaused} duration={12} delay={12000} onEnd={onEnd}/>
            </div>
            
            <button style={styleBtn}
                    onClick={() => setIsPaused(prev => !prev)}>
                Pause {isPaused.toString()}
            </button>
            <button style={styleBtn}
                    onClick={handleStart}>
                Start {isStart.toString()}
            </button>
        </div>
    );
};

export {TmpPage};
